import type {
    MembershipProfileAnswer,
    MembershipProfileAnswerUpsertDto,
    ProfileAnswer,
} from '@fruitful/member-profile';

import { requestBuilder } from '../../http/RequestBuilder';

const useUpsertMembershipProfileAnswer = requestBuilder.mutation<
    Array<MembershipProfileAnswer<ProfileAnswer>>,
    Array<MembershipProfileAnswerUpsertDto<ProfileAnswer>>
>({
    endpoint: '/api/membership-profile/answer',
    method: 'POST',
});

export default useUpsertMembershipProfileAnswer;
